
import { useEffect, useState } from 'react';
import { message } from 'antd';
import { handlers } from '../../../helpers/helpers';
import { admissionService, updateCompany } from '../../../services/admission';
import { consultationService } from '../../../services/medicalConsultation';
import { base64ToStream, uploadAssetController } from '../../../utils/fileUtils';
import { sendAllOrders } from '../../../services/rx';
import { getActiveProviders } from '../../../services/providers';
import { sendOrderToBupa, sendOrderToBionet, sendOrderToSofsalud } from '../../../services/laboratory';
import { sendOrderToBiartic } from '../../../services/optometry';
import { sendOrderToEdxEcg } from '../../../services/ecg';
import { removeAsset } from '../../../services/general';

const { format } = require('rut.js');

const useAdmission = (
  reservation,
  patientToAdmission,
  setPatientToAdmission,
  currentStep,
  setStartAdmission,
  t,
  fromAdmission,
) => {
  const [loading, setLoading] = useState(false);

  const confirmRefreshPage = (event) => {
    event.preventDefault();

    const message = '¿Estás seguro que deseas abandonar?';
    return event.returnValue = message;
  };

  useEffect(() => {
    window.addEventListener('beforeunload', confirmRefreshPage);

    return () => {
      window.removeEventListener('beforeunload', confirmRefreshPage);
    }

  }, [currentStep]);

  const sendCompanyChanges = async (params) => {
    try {
      await updateCompany(params);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al cambiar la compañia a facturar',
        style: {
          marginTop: '45vh',
        },
      });
    }
  }

  const validateAndRefactorData = () => {
    let params = { 'patient': {} };
    const company = {
      invoice_company_id: patientToAdmission.invoice_company_id,
      reservation_id: reservation.id
    };
    for (const key in patientToAdmission) {

      params['patient'] = { ...params['patient'], 'reservation_id': reservation.id };
      params['patient'] = { ...params['patient'], 'user_id': reservation.user_id };

      if (key === 'id') {
        params['patient'] = { ...params['patient'], 'id': patientToAdmission['id'] };
      }
      if (key === 'userFirstName') {
        params['patient'] = { ...params['patient'], 'user_first_name': patientToAdmission['userFirstName'] };
      }
      if (key === 'userLastName') {
        params['patient'] = { ...params['patient'], 'user_last_name': patientToAdmission['userLastName'] };
      }
      if (key === 'dateBirth') {
        params['patient'] = { ...params['patient'], 'date_birth': patientToAdmission['dateBirth'] };
      }
      if (key === 'documentNumber') {
        params['patient'] = { ...params['patient'], 'document_number': patientToAdmission['documentType'] === 'rut' ? format(patientToAdmission['documentNumber'], { dots: false }) : patientToAdmission['documentNumber'] };
      }
      if (key === 'documentType') {
        params['patient'] = { ...params['patient'], 'document_type': patientToAdmission['documentType'] };
      }
      if (key === 'countryCode') {
        params['patient'] = { ...params['patient'], 'country_code': patientToAdmission['countryCode'] };
      }
      if (key === 'genderId') {
        params['patient'] = { ...params['patient'], 'gender_id': patientToAdmission['genderId'] };
      }
      if (key === 'evaluation_type') {
        params['patient'] = { ...params['patient'], 'evaluation_type': patientToAdmission['evaluation_type'] };
      }
      if (key === 'phone') {
        params['patient'] = { ...params['patient'], 'phone': patientToAdmission['phone'] };
      }

      if (key === 'prestations') {

        let newNamedServices = [];

        patientToAdmission['prestations'].forEach(item => {
          return (
            newNamedServices.push({
              'id': item.id,
              'type': item.type,
              'sale_amount': item.sale_amount,
              'currency_id': item.currency_id,
              'department_id': (item.department_id) ? item.department_id : 1,
              'consents': item.consents,
              ...(item.report_type !== undefined && { 'report_type': item.report_type }),
              ...(item.removedExamIds !== undefined && { 'removedExamIds': item.removedExamIds }),
              ...(item.additionals !== undefined && { 'additionals': item.additionals }),
              ...(item.selectedKeywords && { 'selected_keywords': item.selectedKeywords })
            })
          )
        });

        params['patient'] = { ...params['patient'], 'prestations': newNamedServices };
      }

      if (key === 'profession') {
        if (fromAdmission) {
          if (!patientToAdmission['id']) {
            params['patient'] = { ...params['patient'], 'profession': patientToAdmission['profession'] };
            params['patient'] = { ...params['patient'], 'admission_profession': patientToAdmission['profession'] };
          } else {
            params['patient'] = { ...params['patient'], 'profession': patientToAdmission['originalProfession'] || patientToAdmission['profession'] };
            params['patient'] = { ...params['patient'], 'admission_profession': patientToAdmission['profession'] };
          }
        } else {
          params['patient'] = { ...params['patient'], 'profession': patientToAdmission['profession'] };
        }
      }
      if (key === 'validation_token') {
        params['patient'] = { ...params['patient'], 'validation_token': patientToAdmission['validationToken'] };
      }
      if (key === 'fingerprint' && patientToAdmission['fingerprint']?.isNew) {
        params['patient'] = { ...params['patient'], 'fingerprint_image': patientToAdmission['fingerprint']['photo'] };
      }
      if (key === 'email') {
        params['patient'] = { ...params['patient'], 'email': patientToAdmission['email'] === "" ? null : patientToAdmission['email'] };
      }
      if (key === 'signature_image') {
        params['patient'] = { ...params['patient'], 'signature_image': patientToAdmission['signature_image'] };
      }
      if (key === 'consents') {
        params['patient'] = { ...params['patient'], 'consents': patientToAdmission['consents'] };
      }
      if (key === 'diabetic') {
        params['patient'] = { ...params['patient'], 'diabetic': patientToAdmission['diabetic'] };
      }
      if (key === 'address') {
        params['patient'] = { ...params['patient'], 'address': patientToAdmission['address'] };
      }
      if (key === 'commune_id') {
        params['patient'] = { ...params['patient'], 'commune_id': patientToAdmission['commune_id'] };
      }
      if (key === 'area_id') {
        params['patient'] = { ...params['patient'], 'area_id': patientToAdmission['area_id'] };
      }
      if (key === 'job_position_id') {
        params['patient'] = { ...params['patient'], 'job_position_id': patientToAdmission['job_position_id'] };
      }
      if (key === 'project_id') {
        params['patient'] = { ...params['patient'], 'project_id': patientToAdmission['project_id'] };
      }
      if (key === 'external_id') {
        params['patient'] = { ...params['patient'], 'external_id': patientToAdmission['external_id'] };
      }
    }

    return sendPatientAndConsentsForm(params, company);
  };

  const sendPatientAndConsentsForm = async (params, company) => {
    let response;
    try {
      setLoading(true);
      let companyResponse;
      [companyResponse, response] = await Promise.all([
        sendCompanyChanges(company),
        admissionService.sendPatientAndConsents(params),
      ]);
      if (response && response.admission_patient_id) {
        const previousIds = (patientToAdmission['previousPrestations'] || [])
          .map((previous) => `${previous.id}-${previous.type}`);

        const createConsultations = (patientToAdmission['prestations'] || [])
          .filter((prestation) => prestation.type === 'Exam' || prestation.type === 'Battery' || prestation.type === 'Collection')
          .filter((prestation) => !previousIds.includes(`${prestation.id}-${prestation.type}`))
          .map((prestation) =>
            consultationService.saveConsultation({
              admission_patient_id: response.admission_patient_id,
              service_id: prestation.id,
              service_type: prestation.type,
              medical_form_type: prestation.medical_form_type || 'health',
              from_admission: true,
            }).catch((error) => {
              console.error(`Error creating consultation for service ${prestation.id}:`, error);
              return null;
            })
          );

        if (createConsultations.length > 0) {
          await Promise.allSettled(createConsultations);
        }
      }

      if (patientToAdmission.pictureIdCard?.isNew && patientToAdmission.pictureIdCard.photo) {
        const file = base64ToStream(patientToAdmission.pictureIdCard.photo, 'image/png', 'pictureIdCard.png');
        await uploadAssetController({
          file: file,
          object_field: 'document',
          object_type: 'Patient',
          object_id: patientToAdmission.id || response.patient_id,
        });
      } else if (patientToAdmission.pictureIdCard?.isNew) {
        await removeAsset({
          field: 'document',
          id: patientToAdmission.id || response.patient_id,
          type: 'Patient',
        });
      }

      if (patientToAdmission.card_front?.isNew) {
        const fileName = 'card_front.' + patientToAdmission.card_front.type.split('/')[1];
        const file = base64ToStream(patientToAdmission.card_front.photo, patientToAdmission.card_front.type, fileName);
        await uploadAssetController({
          file: file,
          object_field: 'card_front',
          object_type: 'Patient',
          object_id: patientToAdmission.id || response.patient_id,
        });
      }

      if (patientToAdmission.card_back?.isNew) {
        const fileName = 'card_back.' + patientToAdmission.card_back.type.split('/')[1];
        const file = base64ToStream(patientToAdmission.card_back.photo, patientToAdmission.card_back.type, fileName);
        await uploadAssetController({
          file: file,
          object_field: 'card_back',
          object_type: 'Patient',
          object_id: patientToAdmission.id || response.patient_id,
        });
      }

      const examTypes = [
        ...new Set(
          (patientToAdmission?.prestations || []).flatMap((prestation) =>
            prestation.type === 'Exam'
              ? prestation.exam_type
                ? [prestation.exam_type]
                : []
              : (prestation.type === 'Battery' || prestation.type === 'Collection')
                ? prestation.battery_exams?.map((exam) => exam.exam_type).filter(Boolean) || []
                : [],
          ) || [],
        ),
      ];

      const providers = getActiveProviders();
      const hasLaboratoryExams = providers?.[reservation?.branch_office_id]?.laboratory && examTypes.includes('laboratory');
      const hasRxExams = providers?.[reservation?.branch_office_id]?.rx && examTypes.includes('rx');

      const optometryProvider = response.exams_by_provider?.find((provider) => provider.optometry);
      const integrationBiartic = providers?.[reservation?.branch_office_id]?.optometry?.includes('biartic');
      const hasBiarticExams = integrationBiartic && optometryProvider?.optometry?.biartic?.length > 0;

      const ecgProvider = response.exams_by_provider?.find((provider) => provider.ecg);
      const integrationEdxEcg = providers?.[reservation?.branch_office_id]?.ecg?.includes('edx-ecg');
      const hasEcgExams = integrationEdxEcg && ecgProvider?.ecg?.['edx-ecg']?.length > 0;

      if ((hasLaboratoryExams || hasRxExams || hasBiarticExams || hasEcgExams) && !response?.admission_patient_id) {
        let errorMsg;
        if (hasLaboratoryExams && hasRxExams && hasBiarticExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar órdenes de laboratorio, RX y optometría`;
        } else if (hasLaboratoryExams && hasRxExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar órdenes de laboratorio y RX`;
        } else if (hasLaboratoryExams && hasBiarticExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar órdenes de laboratorio y optometría`;
        } else if (hasRxExams && hasBiarticExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar órdenes de RX y optometría`;
        } else if (hasLaboratoryExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar orden de laboratorio`;
        } else if (hasRxExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar orden de RX`;
        } else if (hasEcgExams) {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar orden de ECG`;
        } else {
          errorMsg = `${t('admissionPage.patientEntry.patient')} ingresado con error al enviar orden de optometría`;
        }
        message.warning({
          content: errorMsg,
          style: {
            marginTop: '45vh',
            fontSize: 16,
          },
        });
        setPatientToAdmission();
        setStartAdmission(false);
        return;
      }

      if (hasLaboratoryExams) {
        let bupaRes = null;
        let bionetRes = null;
        let sofsaludRes = null;

        try {
          const promises = [];

          if (providers?.[reservation?.branch_office_id]?.laboratory.includes('bupa')) {
            promises.push(
              sendOrderToBupa({
                admissionPatientId: response.admission_patient_id,
              }),
            );
          } else {
            promises.push(Promise.resolve(null));
          }

          if (providers?.[reservation?.branch_office_id]?.laboratory.includes('bionet')) {
            promises.push(
              sendOrderToBionet({
                admissionPatientId: response.admission_patient_id,
              }),
            );
          } else {
            promises.push(Promise.resolve(null));
          }

          if (providers?.[reservation?.branch_office_id]?.laboratory.includes('sofsalud')) {
            promises.push(
              sendOrderToSofsalud({
                admissionPatientId: response.admission_patient_id,
              }),
            );
          } else {
            promises.push(Promise.resolve(null));
          }

          const [bupaResult, bionetResult, sofsaludResult] = await Promise.all(promises);
          bupaRes = bupaResult;
          bionetRes = bionetResult;
          sofsaludRes = sofsaludResult;

          const isBupaOk = !bupaRes || [200, 208].includes(bupaRes.statusCode);
          const isBionetOk = !bionetRes || [200, 208].includes(bionetRes.statusCode);
          const isSofsaludOk = !sofsaludRes || [200, 208].includes(sofsaludRes.statusCode);

          if (!isBupaOk) {
            message.error({
              content: 'Error al enviar orden a Bupa',
              style: {
                marginTop: '45vh',
                fontSize: 16,
              },
            });
          }
          if (!isBionetOk) {
            message.error({
              content: 'Error al enviar orden a Bionet',
              style: {
                marginTop: '45vh',
                fontSize: 16,
              },
            });
          }
          if (!isSofsaludOk) {
            message.error({
              content: 'Error al enviar orden a Sofsalud',
              style: {
                marginTop: '45vh',
                fontSize: 16,
              },
            });
          }
          if (isBupaOk && isBionetOk && isSofsaludOk) {
            message.success({
              content: 'Paciente ingresado correctamente',
              style: {
                marginTop: '45vh',
                fontSize: 16,
              },
            });
          }
        } catch (error) {
          message.error({
            content: 'Error al enviar orden a laboratorio',
            style: {
              marginTop: '45vh',
              fontSize: 16,
            },
          });
          console.error(error);
        }
      }

      if (hasRxExams) {
        if (providers?.[reservation?.branch_office_id]?.rx.includes('edx')) {
          try {
            await sendAllOrders(response.admission_patient_id);
          } catch (error) {
            message.error({
              content: 'Error al enviar orden a RX',
              style: {
                marginTop: '45vh',
                fontSize: 16,
              },
            });
            console.error(error);
          }
        }
      }

      if (hasBiarticExams) {
        try {
          await sendOrderToBiartic({
            admissionPatientId: response.admission_patient_id,
          });
          message.success({
            content: 'Orden enviada a Biartic correctamente',
            style: {
              marginTop: '45vh',
              fontSize: 16,
            },
          });
        } catch (error) {
          message.error({
            content: 'Error al enviar orden a Biartic',
            style: {
              marginTop: '45vh',
              fontSize: 16,
            },
          });
          console.error(error);
        }
      }

      if (hasEcgExams) {
        try {
          await sendOrderToEdxEcg({
            admissionPatientId: response.admission_patient_id,
          });
          message.success({
            content: 'Orden enviada a ECG correctamente',
            style: {
              marginTop: '45vh',
              fontSize: 16,
            },
          });
        } catch (error) {
          message.error({
            content: 'Error al enviar orden a ECG',
            style: {
              marginTop: '45vh',
              fontSize: 16,
            },
          });
          console.error(error);
        }
      }

      setPatientToAdmission();
      setStartAdmission(false);
    } catch (error) {
      const errorMessage = handlers.isJSON(error) ? JSON.parse(error).message : error;
      console.error('Error interno:', errorMessage);
      message.error({
        content: errorMessage,
        style: {
          marginTop: '45vh',
        },
      });
    } finally {
      if (response?.admission_patient_id) {
        setPatientToAdmission();
        setStartAdmission(false);
      }
      setLoading(false);
    }
  };

  return {
    loading,
    validateAndRefactorData,
  };
};

export default useAdmission;